// © 2015-2021 WDNA - All Rights Reserved

import api, { AxiosRequestConfig } from '../../api/Connect';

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function authorization<T = any>(action: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'login':
      return api.post('auth/login', data, options);
    case 'logout':
      return api.get('auth/logout', data, options);
    case 'myinfo':
      return api.get('auth/myinfo', data, options);
    case 'password':
      return api.post('auth/password', data, options);
    case 'users':
      return api.get('auth/users', data, options);
    case 'get':
      return api.get('auth/get', data, options);
    case 'set':
      return api.post('auth/set', data, options);
    case 'apps':
      return api.get('auth/apps', data, options);
    case 'areas':
      return api.get('auth/areas', data, options);
    case 'departments':
      return api.get('auth/departments', data, options);
    default:
      return undefined;
  }
}
